'use strict';

var calendarsSyncModule = angular.module('t2g.calendarsSync', [
  'gettext',
  'ui.router',
  require('t2g.common.data-access.google-sync').name,
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.notificationService').name,
  require('t2g.common.services.modalService').name,
]);

module.exports = calendarsSyncModule;

calendarsSyncModule.controller('CalendarsSyncCtrl', require('./CalendarsSyncCtrl'));

calendarsSyncModule.controller('CalDavRegisterView', function(
  $scope,
  $uibModalInstance,
  gettextCatalog,
) {
  $scope.isSubmitted = false;

  $scope.caldav = {
    selectedServer: null,
  };

  $scope.knownServers = [
    {
      name: 'icloud',
      url: 'https://caldav.icloud.com/',
    },
    {
      name: 'yahoo',
      url: 'https://caldav.calendar.yahoo.com/',
    },
    {
      name: 'masuyo',
      url: 'https://cal.masuyo.ch',
    },
    {
      name: 'arztekasse_medionline',
      url: 'https://www.medionline.ch/caldav',
    },
    {
      name: gettextCatalog.getString('Custom'),
      url: '',
      custom: true,
    },
  ];

  $scope.currentServerChanged = function() {
    $scope.caldav.provider_name = $scope.caldav.selectedServer.custom
      ? ''
      : $scope.caldav.selectedServer.name;
    $scope.caldav.url = $scope.caldav.selectedServer.url;
  };

  $scope.setProviderName = function(name) {
    $scope.caldav.provider_name = name;
    $scope.caldav.url = $scope.caldav.selectedServer.url;
  };

  $scope.connectProvider = function($event) {
    $scope.isSubmitted = true;

    $event.preventDefault();

    if (!$scope.caldav.provider_name) return;

    $uibModalInstance.close($scope.caldav);
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
});

//  SoftPLUS Company GLN select Controller
calendarsSyncModule.controller('SoftPlusSelectCompanyGlnView', ($scope, $uibModalInstance) => {
  // console.log($scope.$resolve.companyGlns[0]);
  $scope.isSubmitted = false;
  // Set default values
  $scope.softPlus = {
    companyGlns: $scope.$resolve.companyGlns.map(companyGln => ({
      name: companyGln,
    })),
    companyGln: null,
  };

  $scope.currentCompanyGlnChanged = function() {
    $scope.softPlus.companyGln = $scope.softPlus.selectedCompanyGln.name;
  };

  $scope.connectProvider = $event => {
    $scope.isSubmitted = true;

    $event.preventDefault();

    // extract companyGln from softPlus scope
    const { companyGln } = $scope.softPlus;

    // Prevent modal close if companyGln is empty
    if (!companyGln) return;

    $uibModalInstance.close($scope.softPlus);
  };

  $scope.cancel = () => {
    $uibModalInstance.dismiss('cancel');
  };
});

calendarsSyncModule.config(function($stateProvider) {
  $stateProvider.state('private.main.syncCalendars', {
    url: '/calendars-sync',
    title: 'Calendars synchronisation',
    templateUrl: '/app/modules/calendars-sync/CalendarsSyncView.html?v=4.5.6',
    controller: 'CalendarsSyncCtrl as CalendarsSyncCtrl',
    resolve: {
      googleSync: function(GoogleSyncDA) {
        return GoogleSyncDA.getCalendarList();
      },
      calDavProviders: function(CalDavDA, $q) {
        var providers = { caldav_providers: [] };

        return CalDavDA.getList()
          .then(function(response) {
            providers = response.success ? response.providers : providers;
            var promises = [];

            providers.caldav_providers.forEach(function(provider) {
              promises.push(
                CalDavDA.getDiscoveredCalendars(provider.name).then(function(response) {
                  response.forEach(function(calendar) {
                    calendar.value = true;
                  });
                  provider.calendars = response;

                  return provider;
                }),
              );
            });

            return $q.all(promises);
          })
          .then(function() {
            return providers;
          })
          .catch(function() {
            return providers;
          });
      },
      calDavServices: function(CalDavDA) {
        return CalDavDA.getServices();
      },
      resources: function(ResourceDA) {
        return ResourceDA.list().then(function(response) {
          return response.resources;
        });
      },
      softPlusUser(SoftPlusSyncDA) {
        return SoftPlusSyncDA.isSyncing();
      },
    },
  });
});



// WEBPACK FOOTER //
// ./src/app/modules/calendars-sync/calendarsSyncModule.js